module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("Let’s say there had not been a Merle Kilgore. There would have been a big empty spot in [the Country Music] business. He contributed songs; he contributed his knowledge and his friendship in bringing people together. This business is pretty big, but his footprint is over a considerable part of it. His association with Hank Williams, and Hank Williams, Jr., and Johnny Cash—he helped those people. They owed a lot to Merle, and they knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("Ralph Emery")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("Merle was more to me than a manager. He was a father figure, he was a mentor, he was my business advisor; but most of all, Merle Kilgore was my best friend"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#fm1_nt1",
      "id": "fm1_ft1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("Hank Williams, Jr.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 69
// module chunks = 0